// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RaVz","content":"styles_content__289AM"};